/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { useState, useTransition } from 'react';
import styles from './FormSection.module.css';
import Notification from '../Notification/Notification';
import { MessageType } from '../../../interfaces/baseInterface';
import InfoIcon from '@mui/icons-material/Info';
import { Typography } from '@mui/material';
import { useTranslation } from '../Translation/translationProvider';

interface FormSectionProps{
    children:any,
     sectionHeader?: string
  subSectionHeader?: string
  infoData?:string
  title?:string
}

const FormSection:React.FC<FormSectionProps>= (props) =>{

    const {sectionHeader,subSectionHeader,infoData,children}=props
    const {t} = useTranslation();

   const [open, setOpen] = useState(false);

  const handleClose =()=>{
    setOpen(false)
  }
 
  return (
    <div className={styles.formSectionContainer}>
     <Notification
        type={MessageType.dialog}
        open={open}
        handleClose={handleClose}
        title={sectionHeader}
        message={infoData} />

      {sectionHeader && <>
      <div className={styles.sectionHeaderParent}>
        <div className={'sectionHeader'}>
          {t(sectionHeader)}
         
        </div> {infoData && <InfoIcon className='infoIcon' onClick={()=>{setOpen(true)}}/>}
        </div>
        {subSectionHeader && <>
        <br/>
        <Typography
          variant="body1" display="inline" paragraph>
          {t(subSectionHeader)}
        </Typography>
      </>}
      </>}
      {children}
      </div>
  )
}

export default FormSection;